import { css } from 'styled-components';

import { colors, animation } from './constants';

const { shortAnimationDuration, transitionTimingFn } = animation;

export const link = css`
  font-weight: 500;
  color: ${colors.cyan};
  text-decoration: none;
  transition: color ${shortAnimationDuration}ms ${transitionTimingFn};

  &:hover,
  &:active,
  &:focus {
    color: ${colors.cyanHover};
  }
`;

export const navLink = css`
  position: relative;
  font-weight: 600;
  text-decoration: none;
  color: ${props => (props.dark ? colors.graphite : colors.white)};
  transition: color ${shortAnimationDuration}ms ${transitionTimingFn};

  &:after {
    opacity: 0;
    position: absolute;
    content: '';
    width: 100%;
    bottom: 0.1rem;
    left: 0;
    top: 3rem;
    height: 0.3rem;
    background-color: ${props => (props.dark ? colors.graphite : colors.white)};
    transition: opacity ${shortAnimationDuration}ms ${transitionTimingFn};
  }

  &:focus,
  &:hover,
  &.selected {
    color: ${props => (props.dark ? colors.graphite : colors.white)};

    &:after {
      opacity: 1;
    }
  }
`;
